var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "settings" }, [
    _c("div", { staticClass: "container-title" }, [
      _c("div", { staticClass: "left" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("dash.settings.title"))),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "navigation" },
      [
        _c("router-link", { attrs: { to: "/dash/settings/account" } }, [
          _c(
            "div",
            {
              class: {
                btn: true,
                account: true,
                active: _vm.ongletOpen === "account",
              },
            },
            [_vm._v(_vm._s(_vm.$t("dash.settings.nav.account")))]
          ),
        ]),
        _c("router-link", { attrs: { to: "/dash/settings/notifications" } }, [
          _c(
            "div",
            {
              class: {
                btn: true,
                notifications: true,
                active: _vm.ongletOpen === "notifications",
              },
            },
            [_vm._v(_vm._s(_vm.$t("dash.settings.nav.notifications")))]
          ),
        ]),
        _c("router-link", { attrs: { to: "/dash/settings/users" } }, [
          _c(
            "div",
            {
              class: {
                btn: true,
                users: true,
                active: _vm.ongletOpen === "users",
              },
            },
            [_vm._v(_vm._s(_vm.$t("dash.settings.nav.manage_users")))]
          ),
        ]),
        _vm.infoUser.admin
          ? _c("router-link", { attrs: { to: "/dash/settings/billing" } }, [
              _c(
                "div",
                {
                  class: {
                    btn: true,
                    billing: true,
                    active: _vm.ongletOpen === "billing",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dash.settings.nav.billing")))]
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content-section-settings" },
      [
        _vm.ongletOpen == "account"
          ? _c("account", {
              attrs: {
                infoUser: _vm.infoUser,
                infoAccount: _vm.infoAccount,
                updateInfoUser: _vm.updateInfoUser,
                updateInfoAccount: _vm.updateInfoAccount,
              },
            })
          : _vm._e(),
        _vm.ongletOpen == "billing" && _vm.infoUser.admin
          ? _c("billing", {
              attrs: {
                infoUser: _vm.infoUser,
                infoAccount: _vm.infoAccount,
                updateInfoAccount: _vm.updateInfoAccount,
                allPages: _vm.allPages,
              },
            })
          : _vm._e(),
        _vm.ongletOpen == "notifications"
          ? _c("notifications", {
              attrs: {
                infoUser: _vm.infoUser,
                updateInfoUser: _vm.updateInfoUser,
              },
            })
          : _vm._e(),
        _vm.ongletOpen == "users"
          ? _c("users", {
              attrs: {
                pages_access: Array.isArray(_vm.allPages)
                  ? _vm.infoUser.admin
                    ? _vm.allPages
                    : _vm.allPages.filter((page) =>
                        _vm.infoUser.pages_access.includes(page.id)
                      )
                  : [],
                groups: _vm.groups,
                infoUser: _vm.infoUser,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }